import React from 'react';
import { Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Dima, 49',
      role: 'Bürojob',
      text: '"Ich sitze seit Jahren viel am Schreibtisch und hatte ständig Nacken- und Rückenschmerzen. Ich dachte ehrlich: \'Das ist halt das Alter.\' Im Haltung-Reset habe ich zum ersten Mal verstanden, warum es weh tut – und was ich konkret ändern muss. Nach ein paar Wochen wurden die Schmerzen deutlich weniger, und am Ende hatte ich wieder ein normales Körpergefühl. Das Beste: Ich habe einfache Gewohnheiten mitgenommen, die ich im Alltag wirklich durchziehe."'
    },
    {
      name: 'Irina',
      role: 'Mama von 3 Kindern / Haushalt',
      text: '"Ich hatte immer wieder Schmerzen im unteren Rücken – durch Kinder, Haushalt, ständiges Heben und wenig Zeit für mich. Ich war skeptisch, weil ich schon vieles probiert hatte. Alex hat es extrem klar erklärt: erst Diagnose, dann gezielte Übungen statt einfach \'irgendwas machen\'. Nach dem Programm konnte ich mich wieder normal bücken, tragen und schlafen – ohne dieses Ziehen im Rücken. Und ich brauche dafür keine langen Einheiten."'
    },
    {
      name: 'Markus, 36',
      role: 'IT / Homeoffice',
      text: '"Ich habe früher hart trainiert, aber meine Haltung wurde trotzdem schlechter und meine Schultern waren ständig verspannt. Bei Alex war\'s das erste Mal logisch: nicht mehr \'mehr machen\', sondern besser. Die 30-Minuten-Einheiten passen perfekt in meinen Alltag. Ich habe wieder Kontrolle über meine Bewegungen, weniger Druck im Nacken und fühle mich insgesamt stabiler – auch wenn ich viel sitze."'
    },
    {
      name: 'Sabine, 43',
      role: 'Pflege/Schichtarbeit',
      text: '"Ich hatte Rückenprobleme und dachte, Training würde alles nur schlimmer machen. Alex hat mir die Angst genommen, weil es nicht ums \'Durchbeißen\' geht, sondern um saubere Mechanik. Schritt für Schritt: erst Stabilität, dann Kraft. Ich merke jetzt im Alltag, dass ich anders stehe, anders hebe und weniger kompensiere. Das Ergebnis ist nicht nur weniger Schmerz – ich bin auch weniger müde."'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Was Teilnehmer sagen
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Echte Erfahrungen von Menschen, die ihr Leben mit dem Haltung-Reset verändert haben.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 'var(--spacing-large)'
        }}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="network-card" style={{
              cursor: 'default',
              position: 'relative',
              paddingTop: 'var(--spacing-xl)'
            }}>
              <div style={{
                position: 'absolute',
                top: 'var(--spacing-medium)',
                left: 'var(--spacing-medium)',
                color: 'var(--brand-primary)',
                opacity: 0.3
              }}>
                <Quote size={48} />
              </div>
              
              <p className="body-medium" style={{ 
                marginBottom: 'var(--spacing-large)',
                fontStyle: 'italic',
                color: 'var(--text-secondary)',
                lineHeight: 1.7
              }}>
                {testimonial.text}
              </p>
              
              <div style={{
                paddingTop: 'var(--spacing-medium)',
                borderTop: '2px solid var(--border-light)'
              }}>
                <div className="heading-3" style={{ marginBottom: '4px' }}>
                  {testimonial.name}
                </div>
                <div style={{ 
                  fontSize: '0.875rem', 
                  color: 'var(--text-light)',
                  fontWeight: 500
                }}>
                  {testimonial.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
